import { GIFT_LINKS_COPY } from "@/constants/giftLinks";
import type { CampaignDistribution } from "@/interfaces/campaing";
import type { ContactsMenuMode } from "@/interfaces/giftLinks";

/**
 * The one source for which surface a card's contacts item names AND opens: manual links by
 * quantity open gift links; a universal campaign (one shared link) has none, so the item is not
 * offered (null); everything else — manual links tied to a recipient list included — opens contacts.
 */
export function contactsSurface({
  mode,
  linkToList,
}: Pick<CampaignDistribution, "mode" | "linkToList">): ContactsMenuMode | null {
  if (mode === "universal") return null;
  return mode === "manual" && !linkToList ? "giftLinks" : "contacts";
}

/** The contacts entry's label on the campaign card menu, Manage for an editor and Preview for a viewer. */
export function contactsMenuLabel(mode: ContactsMenuMode, canEditCampaign: boolean): string {
  if (mode === "giftLinks") {
    return canEditCampaign ? GIFT_LINKS_COPY.menu.manage : GIFT_LINKS_COPY.menu.preview;
  }
  return canEditCampaign ? "Manage Contacts" : "Preview Contacts";
}
